<template>
  <div class="pod-image-view-wrapper">
    <div v-if="getThumbnail" v-bind:style="getCSS">
    </div>
  </div>
</template>

<script>
export default {
  name: "PodImageView",
  props: {
    pod: {
      type: Object,
      required: true,
    }
  },
  computed: {
    getThumbnail: function() {
      if (this.pod && this.pod.asset && this.pod.asset.thumbnail && this.pod.asset.thumbnail[0]) {
        return this.pod.asset.thumbnail[0].url;
      } else {
        return false;
      }
    },
    getCSS: function() {
      return {
        width: '100%',
        backgroundImage: 'url("' + this.getThumbnail + '")',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        paddingTop: '45%',   // 20:9
      };
    }
  }
}
</script>

<style>
.pod-image-view-wrapper {
  width: 100%;
  padding: 20px;
  border-radius: 10px;

  background-color: rgb(var(--v-theme-tw-surface));
}

/* .v-theme--light .pod-image-view-wrapper {
  background-color: #FFFFFF;
}

.v-theme--dark .pod-image-view-wrapper {
  background-color: #232b36;
} */
</style>
